import { z } from "zod";

// Define the AI schema - this is what the AI model should conform to
export const createEventWithAISchema = z.object({
    name: z.string().describe("The name of the event"),
    description: z.string().describe("The description of the event"),
    physicalLocation: z.object({
        name: z.string().describe("The name of the physical location"),
        utcOffset: z.number().optional(), // we don't save offset in db, but we use it to get the timezone.
    }),
    startDate: z.object({
        date: z
            .string()
            .describe(
                "The date when the event starts. Should be in ISO format like '2023-05-16'",
            ),
        time: z
            .string()
            .describe(
                "The time when the event starts in 24 hour format like '10:00'",
            ),
    }),
    endDate: z.object({
        date: z
            .string()
            .describe(
                "The date when the event ends. Should be in ISO format like '2023-05-16'",
            ),
        time: z
            .string()
            .describe(
                "The time when the event ends in 24 hour format like '11:00'",
            ),
    }),
    timezone: z.string().optional(),
});

// Create a separate type for input after AI response
export type CreateEventWithAIInput = z.infer<typeof createEventWithAISchema>;
